





































































import Vue from "vue";
import AppIcon from "@/components/app-icon.vue";
import { Parent } from "../../../models/Parent";

export default Vue.extend({
  props: {
    parent: { type: Parent },
  },
  components: {
    AppIcon,
  },
});
